// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"style_checkbox__2IJid"};